import { Component } from '@theme/component';

/**
 * KHEMACIZO - Marquesina infinita
 */
export class AnnouncementBar extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.setupMarquee();
    window.addEventListener('resize', this.updateMarqueeDistance);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.updateMarqueeDistance);
    super.disconnectedCallback?.();
  }

  setupMarquee() {
    const track = this.querySelector('.announcement-bar__slides');

    if (!track) return;

    const originals = Array.from(
      track.querySelectorAll('.announcement-bar__slide:not([data-khemacizo-clone])')
    );

    if (!originals.length) return;

    originals.forEach((slide) => {
      slide.setAttribute('aria-hidden', 'false');
    });

    /* Crear una segunda copia */
    if (!track.querySelector('[data-khemacizo-clone="true"]')) {
      originals.forEach((slide) => {
        const clone = slide.cloneNode(true);

        clone.setAttribute('data-khemacizo-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        clone.removeAttribute('ref');

        clone.querySelectorAll('[id]').forEach((element) => {
          element.removeAttribute('id');
        });

        clone.querySelectorAll('a, button').forEach((element) => {
          element.setAttribute('tabindex', '-1');
        });

        track.appendChild(clone);
      });
    }

    /*
     * Esperamos a que el navegador haya calculado
     * tamaños, fuentes, iconos y espacios.
     */
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.updateMarqueeDistance();
      });
    });
  }

  updateMarqueeDistance = () => {
    const track = this.querySelector('.announcement-bar__slides');

    if (!track) return;

    const firstOriginal = track.querySelector(
      '.announcement-bar__slide:not([data-khemacizo-clone])'
    );

    const firstClone = track.querySelector(
      '.announcement-bar__slide[data-khemacizo-clone="true"]'
    );

    if (!firstOriginal || !firstClone) return;

    /*
     * Esta es la distancia EXACTA entre:
     *
     * ENVÍOS original
     *       ↓
     * ENVÍOS duplicado
     *
     * Así el reinicio ocurre exactamente sobre
     * el mismo punto y visualmente desaparece.
     */
    const distance =
      firstClone.getBoundingClientRect().left -
      firstOriginal.getBoundingClientRect().left;

    track.style.setProperty(
      '--marquee-distance',
      `${distance}px`
    );
  };
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define(
    'announcement-bar-component',
    AnnouncementBar
  );
}